import { createApiSelectors } from 'reacticoon/selector'
import { formatUserMe } from 'modules/userMe/format'

export const loginSelectors = createApiSelectors('App::LoginModule', formatUserMe)
